import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_book_accessories: FaireCategoryEntity = {
  token: "catalog_cat_book-accessories",
  type: "category",
  name: "Book accessories",
  count: 1,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
